const podcastTeasersStyle = Object.freeze({
  buttonVariant: 'neutral',
  teasersTitle: 'בפרקים הקודמים',
  teaserBtnTransform: 'translate(50%, 50%)',
});

export default podcastTeasersStyle;
